import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  evidenceRisks,
  miFielDocument,
  updateInvestorRisk,
  createGeneralContract,
  literaxRisks,
  setLoadingState,
  setLoadingMessage
} from 'src/store/User/user.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  PersonalInformationContainer,
  Banner,
  FormContainer,
  FormData,
  FormDataRisks,
  RiskInformation,
  RiskInformationTitle,
  RiskInformationForm,
  ApprovalAndAdvice,
  ApprovalAndAdviceTitle,
  ApprovalAndAdviceForm,
  AboutInvestment,
  AboutInvestmentTitle,
  AboutInvestmentForm,
  InvestorInformation,
  InvestorInformationForm,
  Container
} from './risks.styles';
import getCurrentDate from 'src/functions/getCurrentDate';
import ModalAllDataRequired from 'src/components/shared/modals/allDataRequired/allDataRequired';
import ModalErrorUploadingInput from 'src/components/shared/modals/errorUploadingInput/errorUploadingInput';
import ModalErrorAllYesRisks from 'src/components/shared/modals/errorAllYesRisks/errorAllYesRisks';
import { getInvestorOnboarding } from 'src/graphql/queries';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { useManageSteps } from 'src/hooks/useManageSteps';
import { environment, url } from 'src/environments';

const loadingMessage =
  'Estimado usuario, estamos procesando tu información, esto puede tardar unos minutos. Por favor, no cierres esta ventana.';

export default function Risks() {
  const [data, setData] = useState({});
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [taxId, setTaxId] = useState();
  const [dateOfApplication] = useState(getCurrentDate());
  const [allDataRequired, setAllDataRequired] = useState(false);
  const [errorUploadingInput, setErrorUploadingInput] = useState(false);
  const [errorAllYesRisks, setErrorAllYesRisks] = useState(false);
  const [formData] = useState({});
  const { nextStep } = useManageSteps();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const handleData = (e) => {
    const value = e.target.value;
    const convertedValue = value === 'true' ? true : value === 'false' ? false : value;
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: convertedValue
    }));
  };
  const currentDate = getCurrentDate();
  const [date, time] = currentDate.split('T');
  const [year, month, day] = date.split('-');
  const [hour, minute] = time.split(':');

  //Valida ruta para el botón de regresar
  const validateRoute = () => {
    if (user.typeOfPerson === 'FISICA') {
      navigate('/inversionista/onboarding-user-f');
    } else if (user.typeOfPerson === 'MORAL') {
      navigate('/inversionista/onboarding-data-m');
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getInvestorOnboarding,
          variables: { id: user.id }
        });
        setFullName(data.getInvestor.personalInformation.fullName);
        setEmail(data.getInvestor.personalInformation.email);
        setTaxId(data.getInvestor.personalInformation.RFC);
      } catch (error) {
        console.error(error);
      }
    };
    if (user.id) {
      fetchUserData();
    }
  }, [user.id]);

  const ipv4 = user.ipAddress ? user?.ipAddress[user?.ipAddress?.length - 1].IPv4 : '';

  const sendDataToServer = async (event) => {
    event.preventDefault();
    dispatch(setLoadingState(true));
    dispatch(setLoadingMessage(loadingMessage));
    const timeStamp = Date.now();
    formData.userId = user.id;
    const requiredFields = [
      'loss',
      'liquidity',
      'information',
      'performance',
      'notApproved',
      'notAdvice',
      'investment',
      'disclosedInformation'
    ];
    const allFieldsFilled = requiredFields.every((field) => data[field] !== undefined);
    if (allFieldsFilled) {
      const allYesRisks = requiredFields.every((field) => data[field] === true);
      if (allYesRisks) {
        //Endpoints que generan el sello de tiempo con la data de Metamap
        const literaxBody = {
          id: user.id,
          typeOfUser: 'investor',
          //Timestamp sólo aplica para el endpoint de literax/emision/mati-files
          timestamp: Date.now()
        };
        await axios.post(`${url}/${environment}/admin/literax/all-info-mati`, literaxBody);
        await axios.post(`${url}/${environment}/admin/mati/send-files-to-aws`, literaxBody);
        await axios.post(`${url}/${environment}/admin/literax/emision/mati-files`, literaxBody);
        //endpoint para segmentar la dirección que viene desde Metamap
        await axios.get(`${url}/${environment}/admin/address-parts?id=${user.id}_p`);
        //Endpoints de riesgos
        const updateInput = {
          investorId: user.id,
          loss: data.loss,
          liquidity: data.liquidity,
          information: data.information,
          performance: data.performance,
          notApproved: data.notApproved,
          notAdvice: data.notAdvice,
          investment: data.investment,
          disclosedInformation: data.disclosedInformation,
          createdAt: dateOfApplication,
          updatedAt: dateOfApplication
        };
        const inputPdf = {
          id: user.id,
          loss: true,
          liquidity: true,
          information: true,
          performance: true,
          noApproval: true,
          noAdvice: true,
          investment: true,
          disclosedInformation: true,
          fullName: fullName,
          createdAt: dateOfApplication,
          ip: ipv4,
          timestamp: timeStamp,
          hostname: 'finsphera.com.mx'
        };
        const createDocument = {
          signatories: [
            {
              name: fullName,
              email: email,
              tax_id: taxId
            }
          ],
          updatedAt: dateOfApplication,
          createdAt: dateOfApplication,
          typeOfUser: 'investor',
          typeOfContract: 'contRisk',
          id: user.id,
          key: `${user.id}/contracts/evidenceOfRisks_${timeStamp}.pdf`
        };
        const generalContract = {
          id: user.id,
          day: day,
          month: month,
          year: year,
          hour: hour,
          minute: minute,
          timestamp: timeStamp
        };
        const body = {
          id: user.id,
          typeOfUser: 'investor',
          object: `${user.id}/contracts/evidenceOfRisks_${timeStamp}.pdf`
        };
        try {
          //Dispatch que crea la tabla risk en Dynamo
          await dispatch(updateInvestorRisk(updateInput));
          //Dispatch para crear el pdf del contrato general que se guarda en s3 y después es consumido por el endpoint de MiFiel(Contrato riesgos)
          await dispatch(evidenceRisks(inputPdf));
          /////Dispatch para ejecutar Literax
          await dispatch(literaxRisks(body));
          //Dispatch para mandar llamar de s3 los contratos que se generaron, los guarda en Mifiel y ya de ahí se pueden mostrar para ser firmados.
          await dispatch(miFielDocument(createDocument));
          //Dispatch para crear el pdf del contrato general que se guarda en s3 y después es consumido por el endpoint de MiFiel(Contrato General)
          await dispatch(createGeneralContract(generalContract));
          dispatch(setLoadingState(false));
          await nextStep();
          navigate('/inversionista/onboarding-perfil-uso');
        } catch (error) {
          console.error(error);
          dispatch(setLoadingState(false));
        }
      } else {
        setErrorAllYesRisks(true);
      }
    } else {
      setAllDataRequired(true);
    }
  };

  return (
    <PersonalInformationContainer>
      <ModalErrorAllYesRisks
        showModalErrorAllYesRisks={errorAllYesRisks}
        setErrorAllYesRisks={setErrorAllYesRisks}
      />
      <ModalAllDataRequired
        showModalAllDataRequired={allDataRequired}
        setAllDataRequired={setAllDataRequired}
      />
      <ModalErrorUploadingInput
        showModalErrorUploadingInput={errorUploadingInput}
        setErrorUploadingInput={setErrorUploadingInput}
      />
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_personalInformation5_banner.png`}
            alt="icono informacion personal"
          />
        </figure>
        <h2>Riesgos</h2>
      </Banner>
      <FormContainer>
        <FormData>
          <FormDataRisks>
            <RiskInformation>
              <RiskInformationTitle>
                <h3>1. Información de riesgos</h3>
                <div>
                  <p>Sí</p>
                  <span></span>
                  <p>No</p>
                </div>
              </RiskInformationTitle>
              <RiskInformationForm>
                <div>
                  <p>
                    <span>Riesgo de pérdida.-</span> ¿Comprende que estas inversiones son riesgosas
                    y que puede perder todo el dinero invertido?
                  </p>
                  <div>
                    <input type="radio" name="loss" onChange={handleData} value={true} />
                    <input type="radio" name="loss" onChange={handleData} value={false} />
                  </div>
                </div>
                <div>
                  <p>
                    <span>Riesgo de liquidez.-</span> ¿Comprende que es posible que no podrá
                    deshacerse anticipadamente de su inversión?
                  </p>
                  <div>
                    <input type="radio" name="liquidity" onChange={handleData} value={true} />
                    <input type="radio" name="liquidity" onChange={handleData} value={false} />
                  </div>
                </div>
                <div>
                  <p>
                    <span>Riesgo de información.-</span> ¿Comprende que es posible que la
                    información que Finsphera proporcione sobre la oferta y el desempeño sucesivo de
                    los Solicitantes de financiamiento, sea limitada?
                  </p>
                  <div>
                    <input type="radio" name="information" onChange={handleData} value={true} />
                    <input type="radio" name="information" onChange={handleData} value={false} />
                  </div>
                </div>
                <div>
                  <p>
                    <span>Riesgo de rendimiento.-</span> ¿Comprende que es posible que no obtenga
                    ingreso o rendimiento alguno, tales como dividendos o intereses, por estas
                    inversiones?
                  </p>
                  <div>
                    <input type="radio" name="performance" onChange={handleData} value={true} />
                    <input type="radio" name="performance" onChange={handleData} value={false} />
                  </div>
                </div>
              </RiskInformationForm>
            </RiskInformation>
            <ApprovalAndAdvice>
              <ApprovalAndAdviceTitle>
                <h3>2. Aprobación y asesoría</h3>
                <div>
                  <p>Sí</p>
                  <span></span>
                  <p>No</p>
                </div>
              </ApprovalAndAdviceTitle>
              <ApprovalAndAdviceForm>
                <div>
                  <p>
                    <span>Sin aprobación.-</span> ¿Comprende que las ofertas de inversión publicadas
                    no han sido revisadas o aprobadas en forma alguna por la Comisión Nacional
                    Bancaria y de Valores u otra autoridad?
                  </p>
                  <div>
                    <input type="radio" name="notApproved" onChange={handleData} value={true} />
                    <input type="radio" name="notApproved" onChange={handleData} value={false} />
                  </div>
                </div>
                <div>
                  <p>
                    <span>Sin asesoría.-</span> ¿Comprende que no recibirá asesoría sobre si las
                    inversiones son adecuadas para usted?
                  </p>
                  <div>
                    <input type="radio" name="notAdvice" onChange={handleData} value={true} />
                    <input type="radio" name="notAdvice" onChange={handleData} value={false} />
                  </div>
                </div>
              </ApprovalAndAdviceForm>
            </ApprovalAndAdvice>
            <AboutInvestment>
              <AboutInvestmentTitle>
                <h3>3. Acerca de la inversión</h3>
                <div>
                  <p>Sí</p>
                  <span></span>
                  <p>No</p>
                </div>
              </AboutInvestmentTitle>
              <AboutInvestmentForm>
                <div>
                  <p>
                    <span>Riesgo de inversión.-</span> ¿Ha leído este formulario y comprende los
                    riesgos de llevar a cabo estas inversiones?
                  </p>
                  <div>
                    <input type="radio" name="investment" onChange={handleData} value={true} />
                    <input type="radio" name="investment" onChange={handleData} value={false} />
                  </div>
                </div>
                <div>
                  <div>
                    <p>
                      <span>Información divulgada.-</span> Antes de invertir, deberá leer
                      cuidadosamente la información divulgada por cada uno de los Solicitantes de
                      financiamiento en los que usted considere realizar la inversión. Si no ha
                      leído o no comprende dicha información, usted no debería invertir.
                    </p>
                    <div>
                      <p>
                        ¿Comprende que, además de los riesgos generales de la inversión, deberá leer
                        y entender la información divulgada por los Solicitantes de financiamiento?
                      </p>
                      <div>
                        <input
                          type="radio"
                          name="disclosedInformation"
                          onChange={handleData}
                          value={true}
                        />
                        <input
                          type="radio"
                          name="disclosedInformation"
                          onChange={handleData}
                          value={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </AboutInvestmentForm>
            </AboutInvestment>
            <InvestorInformation>
              <InvestorInformationForm>
                <div>
                  <div>
                    <p>Nombre completo:</p>
                    <p>{fullName}</p>
                  </div>
                  <div>
                    <p>Fecha de aplicación del cuestionario:</p>
                    {new Date(dateOfApplication).toLocaleDateString()}
                  </div>
                </div>
                <div>
                  <p>
                    <span>Firma electrónica.-</span> Al hacer click en el botón &quot;ACEPTO
                    RIESGOS&quot;, reconozco que estoy firmando este formulario electrónicamente,
                    produciendo los mismos efectos que las leyes otorgan a la firma autógrafa.
                  </p>
                </div>
              </InvestorInformationForm>
            </InvestorInformation>
          </FormDataRisks>
        </FormData>
      </FormContainer>
      <Container>
        <Button size="small" onClick={validateRoute}>
          Anterior
        </Button>
        {/* <Link to="/inversionista/onboarding-data-m">Anterior</Link> */}
        <Button size="small" onClick={sendDataToServer}>
          Acepto riesgos
        </Button>
      </Container>
    </PersonalInformationContainer>
  );
}
